import { FC } from 'react';
// import cs from 'classnames';
// import styles from './entry.module.less';
import { isNotEmpty } from '@lhb/func';

/**
 * @Description 分为区分年份的表格（单行内展示第一年、第二年数据）
 */
const YearDataInput: FC<{
  record: any;
  columnItem: any;
}> = ({
  record,
  columnItem,
}) => {
  const { dataIndex } = columnItem || {};

  const renderInput = (record: any) => {
    return <>{isNotEmpty(record[dataIndex]) ? `${record[dataIndex]}${record?.unitDetail || ''}` : '-'}</>;
  };

  const renderName = (record: any) => {
    return <>
      {/* {record?.required ? <span className='c-f23'>*</span> : ' '} */}
      {record?.name}
    </>;
  };

  return columnItem?.isInput ? renderInput(record) : renderName(record);
};

export default YearDataInput;
